import { render, staticRenderFns } from "./_albumId.vue?vue&type=template&id=6a1ebcde&scoped=true"
import script from "./_albumId.vue?vue&type=script&lang=ts"
export * from "./_albumId.vue?vue&type=script&lang=ts"
import style0 from "./_albumId.vue?vue&type=style&index=0&id=6a1ebcde&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1ebcde",
  null
  
)

export default component.exports